import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/app/[locale]/integrations/[slug]/integration.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/node_modules/next/dist/client/link.js");
